(function(wndw) {
  var jadify = function(jade, _t, _h) {
    var yudify = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span class=\"cif-stack cif-2x\"><em class=\"cif-circle cif-stack-2x cif-inverse\"></em><em class=\"cif-play-circle cif-stack-2x\"></em></span>");;return buf.join("");
};
    return function(locals) {
      if (locals) {
        if ("_t" in locals) { _t = locals._t.merge(_t); }
        // Jade helper objects must define this merge method.
      }
      return yudify(locals);
    };
  };
  if(typeof define === "function" && define.amd) {
    define([
      "js/vendor/jade"
      ,"i18n!bundles/videojs/layout/nls/circlePlayButton"
    ], function(
      jade
      ,_t
    ) {
      var _h;
      return jadify(jade, _t, _h);
    });
  } else {
    wndw.jade.templates["bundles.videojs.layout.circlePlayButton"] = jadify(wndw.jade.helpers);
  }
})(window);
